
import {ReactComponent as HomeLineIcon} from '../../assets/images/home-line.svg';
import {ReactComponent as Home04Icon} from '../../assets/images/home-04.svg';
import {ReactComponent as UserDownIcon} from '../../assets/images/user-down.svg';
import {ReactComponent as GridIcon} from '../../assets/images/grid.svg';
import ReceiptIcon from '@mui/icons-material/Receipt';


import BookOnlineTwoToneIcon from '@mui/icons-material/BookOnlineTwoTone';
import DescriptionIcon from '@mui/icons-material/Description';
import VerifiedIcon from '@mui/icons-material/Verified';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import VisibilityIcon from '@mui/icons-material/Visibility';


import {ReactComponent as DocumentsIcons} from '../../assets/images/mi-portal/documentos.svg';
import {ReactComponent as RequestVacationsIcons} from '../../assets/images/mi-portal/solicitar-vacaciones.svg';
import {ReactComponent as MyFileIcons} from '../../assets/images/mi-portal/mi-ficha.svg';
import {ReactComponent as BenefitsIcons} from '../../assets/images/mi-portal/beneficios.svg';

import {ReactComponent as CakeIcon} from '../../assets/images/app-menu/cake.svg';
import {ReactComponent as FileCheckIcon} from '../../assets/images/app-menu/file-check.svg';
import {ReactComponent as BookOpenIcon} from '../../assets/images/app-menu/book-open.svg';
import {ReactComponent as DataflowIcon} from '../../assets/images/app-menu/dataflow.svg';


import {ReactComponent as ClockSnoozeIcon} from '../../assets/images/a-mi-cargo/clock-snooze.svg';
import {ReactComponent as Users03Svg} from '../../assets/images/a-mi-cargo/users-03.svg';

import {ReactComponent as AreasIcon} from '../../assets/images/administracion/areas.svg';
import {ReactComponent as CouponIcon} from '../../assets/images/administracion/coupons.svg';
import EventIcon from '@mui/icons-material/Event';
import GroupsIcon from '@mui/icons-material/Groups';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

interface MenuIcons {
    [key: string]: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};
  
const menuIcons: MenuIcons = {
    "Grupos de notificación": () => <GroupsIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    
    "Registro de Asistencia": () => <EventIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    "Panel": () => <DashboardIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    "Marcaciones": () => <WorkHistoryIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    "A mi cargo": UserDownIcon,
    "Administración": GridIcon,
    "Aprobaciones": FileCheckIcon,
    "Ausencias": ClockSnoozeIcon,
    "Grupos de aprobación": Users03Svg,
    "Boletas de Pago": () => <ReceiptIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    "Contratos": () => <DescriptionIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    "Constancias": () => <VerifiedIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,

    "Contratos de colaboradores": () => <DescriptionIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    "Boletas de pago": () => <ReceiptIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    "Vacaciones": RequestVacationsIcons,
    "Resumen de Vacaciones": () => <BeachAccessIcon style={{color: "#B8B8B8", width: "1.5rem", height: "1.5rem",}} />,
    "Gestión de Licencias": () => <AssignmentIcon style={{color: "#B8B8B8", width: "1.5rem", height: "1.5rem",}} />,
    
    
    "Mi Portal": HomeLineIcon,
    "Documentos": DocumentsIcons,
    "Mi ficha": MyFileIcons,
    "Beneficios": BenefitsIcons,
    "Mis Prestamos": () => <AttachMoneyIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,

    "General": Home04Icon,
    "Cumpleaños": CakeIcon,
    "Publicaciones": () => <BookOnlineTwoToneIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    "Organigrama": DataflowIcon,
    "Directorio": BookOpenIcon,
    "Aprobar Publicaciones": FileCheckIcon,
    "Programación": () => <CalendarMonthIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    "Calendario": () => <CalendarMonthIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    
    "Áreas": AreasIcon,
    "Cupones": CouponIcon,
    "Configuración de tipos de ausencia": CouponIcon,

    "Aprobación": () => <DoneAllIcon style={{color: "#B8B8B8", width: "1.5rem", height: "1.5rem",}} />,

    "Gestión": () => <VisibilityIcon style={{color: "#B8B8B8", width: "1.5rem", height: "1.5rem",}} />,
    "Prestamos": () => <AttachMoneyIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    
    "Emails Rechazados": () => <ThumbDownIcon style={{color: "#B8B8B8", width: "1.125rem", height: "1.125rem",}} />,
    
}

export default menuIcons